import z from "zod";
import { ALERT_LEVEL_TYPES } from "../../alerts";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const alertFormSchema = z
	.object({
		title: z.string().min(1),
		description: z.string().min(1),
		href: ZodStringNullable,
		levelType: z.enum(ALERT_LEVEL_TYPES),
		startDate: ZodStringNullable,
		endDate: ZodStringNullable,
		hasDateLimit: z.boolean().default(false),
		isDismissable: z.boolean().default(false),
		teamIds: z.array(z.string()).default([]),
	})
	.transform((values) => {
		if (!values.hasDateLimit) {
			values.endDate = null;
			values.startDate = null;
		}
		return values;
	})
	.superRefine((values, context) => {
		if (values.hasDateLimit) {
			if (!values.endDate) {
				context.addIssue({
					code: "custom",
					message: "Required",
					path: ["endDate"],
				});
			}
			if (!values.startDate) {
				context.addIssue({
					code: "custom",
					message: "Required",
					path: ["startDate"],
				});
			}
		}
	});

export type AlertFormSchema = z.infer<typeof alertFormSchema>;
